import { render, staticRenderFns } from "./LicenseServer.vue?vue&type=template&id=3707312b"
import script from "./LicenseServer.vue?vue&type=script&lang=ts"
export * from "./LicenseServer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports